import { render, staticRenderFns } from "./GlobalHeader.vue?vue&type=template&id=6d229060&scoped=true"
import script from "./GlobalHeader.vue?vue&type=script&lang=js"
export * from "./GlobalHeader.vue?vue&type=script&lang=js"
import style0 from "./GlobalHeader.vue?vue&type=style&index=0&id=6d229060&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d229060",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d229060')) {
      api.createRecord('6d229060', component.options)
    } else {
      api.reload('6d229060', component.options)
    }
    module.hot.accept("./GlobalHeader.vue?vue&type=template&id=6d229060&scoped=true", function () {
      api.rerender('6d229060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/GlobalHeader.vue"
export default component.exports